var map = {
	"./add.png": "0970",
	"./album.png": "8568",
	"./avatar.png": "2c18",
	"./camera.png": "4343",
	"./dir.png": "d4e7",
	"./doctor-avatar.png": "8d64",
	"./msgerr.png": "358c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a304";